import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from "./components/Navbar/Navbar";
import Home from './pages/Home';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Contact from './pages/Contact';
import About from './pages/About';
import NotFound from './pages/NotFound';
import ManufacturingProcess from './pages/ManufacturingProcess';
import OurProductsPage from './pages/OurProductsPage';
import WhyChooseIESGear from './components/WhyChooseBlueRent';

import BoxingGlovesPage from "./pages/Products/BoxingGlovesPage";
import BagGlovesPage from "./pages/Products/BagGlovesPage";
import FocusPadsPage from "./pages/Products/FocusPadsPage";
import PunchingBagsPage from "./pages/Products/PunchingBagsPage";
import HeadGuardsPage from "./pages/Products/HeadGuardsPage";
import SetPage from "./pages/Products/SetPage";
import ThankYou from './pages/ThankYou';


import BoxingShortsPage from './pages/Products/BoxingShorts';
import BoxingVestPage from './pages/Products/BoxingVestPage';
import TeamUniformPage from './pages/Products/TeamUniformPage';
import TaekwondoUniformPage from './pages/Products/TaekwondoUniform';
import BasketballPage from './pages/Products/BagGlovesPage';
import LeadPopup from './components/Leadpopup';
import WhatsAppButton from './components/WhatsappButton';
import DesignerPage from './pages/DesignerPage';

function App() {
  return (
    <Router>
       <Navbar /> 
      <ScrollToTop />

      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" exact element={
          <>
           <LeadPopup/><Home/>
          </>} />
        <Route path="/about" element={<About />} />
        <Route path="/design-your-t-shirt" element={<DesignerPage />} />
        <Route path="/manufacturing-process" element={<ManufacturingProcess />} />
        <Route path="/our-product-page" element={<OurProductsPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/thank-you" element={<ThankYou />} />


        {/* Product Category Pages */}
        <Route path="/products/boxing-gloves" element={<BoxingGlovesPage />} />
        <Route path="/products/bag-gloves" element={<BagGlovesPage />} />
        <Route path="/products/focus-pads" element={<FocusPadsPage />} />
        <Route path="/products/punching-bags" element={<PunchingBagsPage />} />
        <Route path="/products/head-guard" element={<HeadGuardsPage />} />
        <Route path="/products/other-equipment" element={<SetPage />} />
        <Route path="/products/boxing-shorts" element={<BoxingShortsPage />} />
        <Route path="/products/boxing-vest" element={<BoxingVestPage />} />
        <Route path="/products/team-uniform" element={<TeamUniformPage />} />
        <Route path="/products/taekwondo-uniform" element={<TaekwondoUniformPage />} />
        <Route path="/products/basketball" element={<BasketballPage />} />

      </Routes>

      <WhyChooseIESGear /> 
       <Footer /> 

      {/* WhatsApp Floating Button */}
      <WhatsAppButton/>
    </Router>
  );
}

export default App;